import React from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { fetchOrders, editOrder } from '../../actions/orderActions'
import Select from 'react-select'
import isEmpty from 'lodash/isEmpty'
import classnames from 'classnames'
import { sortOpts } from '../../utils/utils'
import Form from '../ui/Form'

function validateInput(data) {
  let errors = {};
  if (data.order_comp_id === 0) {
    errors.order_comp_id = 'Это обязательное поле';
  }
  if (data.order_comp1_id === 0) {
    errors.order_comp1_id = 'Это обязательное поле';
  }
  if (data.order_stts_id === 0) {
    errors.order_stts_id = 'Это обязательное поле';
  }
  if (data.order_place_id === 0) {
    errors.order_place_id = 'Это обязательное поле';
  }
  if (data.order_etype_id === 0) {
    errors.order_etype_id = 'Это обязательное поле';
  }
  if (data.order_product_id === 0) {
    errors.order_product_id = 'Это обязательное поле';
  }
  if (data.order_perc_id === 0) {
    errors.order_perc_id = 'Это обязательное поле';
  }
  if (data.order_taxperc_id === 0) {
    errors.order_taxperc_id = 'Это обязательное поле';
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class EditOrderForm extends Form {

  constructor(props) {
    super(props);
    this.state = {
      data: {
        order_stts_id: props.default_order_stts_id,
        order_etype_id: 0,
        order_product_id: 0,
        order_comp_id: 0,
        order_comp1_id: 0,
        order_empl1: props.user_id,
        order_empl2: props.user_id,
        order_place_id: 0,
        order_perc_id: 0,
        order_taxperc_id: 0,
        order_desc: '',
        order_note: '',
        order_contract: '',
        order_edate: moment().format('Y-MM-DD')
      },
      errors: {}
    }
  }


  componentWillMount(){
    this.props.fetchOrders();
  }

  createOrder = e => {
    e.preventDefault();
    const { errors, isValid } = validateInput(this.state.data);
    if(isValid){
      this.setState({errors: {}});
      this.props.editOrder(this.state.data, (err, id) => {
        if (err) {
          this.setState({
            errors: err
          });
          return;
        }
        this.context.router.push('/order/edit?id='+id);
      });
    }
    else{
      this.setState({
        errors: errors
      });
    }
  }

  cancelEdit = e => {
    e.preventDefault();
    this.context.router.goBack();
  }

  updateStts = e => {
    e.preventDefault();
    this.setState({
      data: {
        ...this.state.data,
        order_stts_id: parseInt(e.target.value,10)
      }
    });
  }

  render() {
    if(isEmpty(this.props.sttss)
      || isEmpty(this.props.comps)
      || isEmpty(this.props.percs)
      || isEmpty(this.props.places)
      || isEmpty(this.props.etypes)
      || isEmpty(this.props.products)
      || isEmpty(this.props.empls)
    ){
      return(<div>Не загружены данные</div>);
    }
    const { percs, sttss, comps, places, etypes, products, comprights, empls } = this.props;

    const { errors, data } = this.state;

    var mappedStts = [];
    var sttsColor = '';
    for (var key in sttss){
      if(sttss.hasOwnProperty(key) && sttss[key].stts_active) {
        sttsColor = data.order_stts_id === parseInt(key,10) ? sttss[key].stts_color_id : 'white'
        mappedStts.push(
          <button
            className="btn"
            style={{backgroundColor:sttsColor}}
            key={key}
            value={key}
            onClick={this.updateStts}
          >
            {sttss[key].stts_desc}
          </button>
        );
      }
    }
    var compsOpt = [];
    var comps1Opt = [];
    for (key in comps){
      if(comps.hasOwnProperty(key) && comps[key].comp_active) {
        if(comps[key].comp_own && comprights.indexOf(parseInt(key,10))!==-1){
          comps1Opt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
        }
        if(comps[key].comp_order || comps[key].comp_id === data.order_comp_id){
          compsOpt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
        }
      }
    }
    compsOpt.sort(sortOpts);
    comps1Opt.sort(sortOpts);
    var emplsOpt = [];
    for (key in empls){
      if(empls.hasOwnProperty(key) && empls[key].user_active) {
        emplsOpt.push({
          value: empls[key].user_id,
          label: empls[key].user_fname + " " + empls[key].user_lname
        });
      }
    }
    emplsOpt.sort(sortOpts);
    var placesOpt = [];
    for (key in places){
      if(places.hasOwnProperty(key) && places[key].place_active) {
        placesOpt.push({value:places[key].place_id,label:places[key].place_desc});
      }
    }
    placesOpt.sort(sortOpts);
    var etypesOpt = [];
    for (key in etypes){
      if(etypes.hasOwnProperty(key) && etypes[key].etype_active) {
        etypesOpt.push({value:etypes[key].etype_id,label:etypes[key].etype_desc});
      }
    }
    etypesOpt.sort(sortOpts);
    var productsOpt = [];
    for (key in products){
      if(products.hasOwnProperty(key) && products[key].product_active) {
        productsOpt.push({value:products[key].product_id,label:products[key].product_desc});
      }
    }
    productsOpt.sort(sortOpts);
    var percsOpt = [];
    for (key in percs){
      if(percs.hasOwnProperty(key) && percs[key].perc_active) {
        percsOpt.push({value:percs[key].perc_id,label:percs[key].perc_desc});
      }
    }
    percsOpt.sort(sortOpts);

    return (
      <div>
        <div className="form-group">
          <div className="pull-right">{mappedStts}</div>
          <button
            type="button"
            className="btn btn-default"
            onClick={this.cancelEdit}
          >
            Назад
          </button>
        </div>
        <h2>Новый заказ</h2>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-horizontal">
              <div className="form-group">
                <label className="control-label col-sm-4">Дата проведения</label>
                <div className="col-sm-8">
                  <DatePicker
                    className="form-control"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={moment(data.order_edate)}
                    onChange={e => this.updateDate(e, 'order_edate')}
                  />
                </div>
              </div>
              <div className={classnames('form-group', { 'has-error': errors.order_comp1_id })}>
                <label className="control-label col-sm-4">Организатор</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={comps1Opt}
                  value={data.order_comp1_id}
                  onChange={e => this.updateSelect(e,'order_comp1_id')}
                />
                {errors.order_comp1_id && <span className="help-block">{errors.order_comp1_id}</span>}
              </div>
              <div className={classnames('form-group', { 'has-error': errors.order_comp_id })}>
                <label className="control-label col-sm-4">Заказчик</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={compsOpt}
                  value={data.order_comp_id}
                  onChange={e => this.updateSelect(e,'order_comp_id')}
                />
                {errors.order_comp_id && <span className="help-block">{errors.order_comp_id}</span>}
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">Контракт</label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control"
                    value={data.order_contract}
                    name="order_contract"
                    onChange={this.updateInput}
                  />
                </div>
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">Название</label>
                <div className="col-sm-8">
                  <textarea
                    className="form-control"
                    value={data.order_desc}
                    name="order_desc"
                    onChange={this.updateInput}
                  />
                </div>
              </div>
              <div className='form-group'>
                <label className="control-label col-sm-4">Аккаунт менеджер</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={emplsOpt}
                  value={data.order_empl1}
                  onChange={e => this.updateSelect(e,'order_empl1')}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-horizontal">
              <div className={classnames('form-group', { 'has-error': errors.order_etype_id })}>
                <label className="control-label col-sm-4">Направление</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={etypesOpt}
                  value={data.order_etype_id}
                  onChange={e => this.updateSelect(e,'order_etype_id')}
                />
                {errors.order_etype_id && <span className="help-block">{errors.order_etype_id}</span>}
              </div>
              <div className={classnames('form-group', { 'has-error': errors.order_product_id })}>
                <label className="control-label col-sm-4">Продукт</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={productsOpt}
                  value={data.order_product_id}
                  onChange={e => this.updateSelect(e,'order_product_id')}
                />
                {errors.order_product_id && <span className="help-block">{errors.order_product_id}</span>}
              </div>
              <div className={classnames('form-group', { 'has-error': errors.order_place_id })}>
                <label className="control-label col-sm-4">Площадка</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={placesOpt}
                  value={data.order_place_id}
                  onChange={e => this.updateSelect(e,'order_place_id')}
                />
                {errors.order_place_id && <span className="help-block">{errors.order_place_id}</span>}
              </div>
              <div className={classnames('form-group', { 'has-error': errors.order_perc_id || errors.order_taxperc_id })}>
                <label className="control-label col-sm-4">Надбавка / налог</label>
                <Select
                  className="col-sm-4"
                  clearable={false}
                  options={percsOpt}
                  value={data.order_perc_id}
                  onChange={e => this.updateSelect(e,'order_perc_id')}
                />
                <Select
                  className="col-sm-4"
                  clearable={false}
                  options={percsOpt}
                  value={data.order_taxperc_id}
                  onChange={e => this.updateSelect(e,'order_taxperc_id')}
                />
                {errors.order_perc_id && <span className="help-block">{errors.order_perc_id}</span>}
                {errors.order_taxperc_id && <span className="help-block">{errors.order_taxperc_id}</span>}
              </div>
              <div className="form-group">
                <label className="control-label col-sm-4">Заметка</label>
                <div className="col-sm-8">
                  <textarea
                    className="form-control"
                    value={data.order_note}
                    name="order_note"
                    onChange={this.updateInput}
                  />
                </div>
              </div>
              <div className='form-group'>
                <label className="control-label col-sm-4">Проджект менеджер</label>
                <Select
                  className="col-sm-8"
                  clearable={false}
                  options={emplsOpt}
                  value={data.order_empl2}
                  onChange={e => this.updateSelect(e,'order_empl2')}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="text-center">
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          <button disabled={false}
            type="button" className="btn btn-primary"
            onClick={this.createOrder}>
            Сохранить
          </button>
        </div>
      </div>
    );
  }
}

EditOrderForm.contextTypes = {
  router: PropTypes.object.isRequired
}

function mapOrdersToProps(store) {
  return {
    comps: store.comps.data,
    empls: store.empls,
    percs: store.percs.data,
    etypes: store.etypes.data,
    products: store.products.data,
    places: store.places.data,
    sttss: store.sttss.data,
    comprights: store.auth.comprights,
    user_id: store.auth.user.user_id,
    default_order_stts_id: store.settings.default_order_stts_id
  }
}

export default connect(mapOrdersToProps, { editOrder, fetchOrders })(EditOrderForm);



// WEBPACK FOOTER //
// ./src/components/order/CreateOrderForm.js